import styled from 'styled-components';
import { Colors } from 'styles';
import { DefaultRow } from 'common/Table';
import { ActionButton } from './ActionButton';

export const Row = styled(({ children, ...props }) => {
  return (
    <DefaultRow
      css={`
        background-color: ${props.row.index === props.highlightRow ? Colors.blue3 : 'inherit'};
      `}
      {...props}
    >
      {children}
    </DefaultRow>
  );
})`
  * {
    color: ${Colors.gray10};
  }
  position: relative;
  height: 40px;
  border-bottom: 1px solid #ffffff21; /* kinda like Gray3, but relative to background color */
  &:last-child {
    border-bottom-width: 0;
  }

  ${ActionButton} {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
  &:hover ${ActionButton}, &:focus ${ActionButton} {
    opacity: 1;
  }
`;
